// extracted by mini-css-extract-plugin
export var legendIndicator = "_cy-1";
export var legendRight = "_cy-0";